import { Alert as ChakraAlert } from '@chakra-ui/react';
import { forwardRef } from 'react';

export interface AlertProps {
  status: 'info' | 'warning' | 'success' | 'error';
  title: string;
  children?: React.ReactNode;
}

export const Alert = forwardRef<HTMLDivElement, AlertProps>(
  ({ status, title, children }, ref) => {
    return (
      <ChakraAlert.Root status={status} ref={ref}>
        <ChakraAlert.Indicator />
        <ChakraAlert.Content>
          <ChakraAlert.Title>{title}</ChakraAlert.Title>
          {children && <ChakraAlert.Description>{children}</ChakraAlert.Description>}
        </ChakraAlert.Content>
      </ChakraAlert.Root>
    );
  }
);

Alert.displayName = 'Alert';
